@if (canRender) {
  <ag-login [isGipLogin]="isGipLogin" [gip]="gip" [dataid]="dataid"></ag-login>
}
